import React, { useState } from "react";
import "./SuccessComponent.css";
import 'bootstrap-icons/font/bootstrap-icons.css';

const SuccessComponent = React.forwardRef((_, ref) => {
  const [isVisible, setIsVisible] = useState(false);
  const [message, setMessage] = useState({ sms: "", pops: "" });

  const showPopup = (sms, iconClass) => {
    const pops = `<i class="${iconClass} custom-icon"></i>`;
    setMessage({ sms, pops });
    setIsVisible(true);

    const timer = setTimeout(() => {
      closePopup();
    }, 5000);

    return () => clearTimeout(timer);
  };

  const closePopup = () => {
    setIsVisible(false);
  };

  React.useImperativeHandle(ref, () => ({
    showPopup,
  }));

  return (
    isVisible && (
      <>
        <div className="overlay-sucess" onClick={closePopup}></div>
        <div className="popup-sucess">
          <button className="popup-btns-sucess" onClick={closePopup}>
            <i className="bi bi-x"></i>
          </button>
          <br />
          <span
            className="icon-span-sucess"
            dangerouslySetInnerHTML={{ __html: message.pops }}
          ></span>
          <p className="pop-content-sucess">{message.sms}</p>
        </div>
      </>
    )
  );
});

export default SuccessComponent;
